import React, { useState } from "react";
import { Link } from "react-router-dom";
import { requestPasswordReset, useAppDispatch } from "../redux";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";

const RequestPasswordReset = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const dispatch = useAppDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await dispatch(requestPasswordReset(email)).unwrap();
      setSuccess(true);
    } catch (error) {
      setError(
        typeof error === "string"
          ? error
          : error?.message || "Failed to request password reset"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div
        className="container-fluid auth-container"
        style={{
          minHeight: "calc(100vh - 200px)",
          paddingTop: "10rem",
          paddingBottom: "8rem",
        }}
      >
        <div
          className="container d-flex justify-content-center align-items-center"
          style={{ minHeight: "50vh" }}
        >
          <div
            className="card p-4 shadow-lg"
            style={{ width: "100%", maxWidth: "400px" }}
          >
            <h3 className="text-center mb-4">Reset Password</h3>

            {success ? (
              <div className="text-center">
                <div className="alert alert-success" role="alert">
                  Reset code has been sent to your email. Please check your
                  inbox.
                </div>
                <Link to="/verify-reset-code" className="btn btn-primary">
                  Enter Reset Code
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}

                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email address
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={loading}
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send Reset Code"}
                </button>

                <div className="text-center mt-3">
                  <small className="text-muted">
                    Remember your password? <Link to="/login">Login</Link>
                  </small>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default RequestPasswordReset;
